export default __webpack_public_path__ + "static/media/quiz-pic-4.6df01a26.jpeg";